import { useAuthenticator } from "@aws-amplify/ui-react";
import { getQuicksightDashboardEmbedUrl } from "api/Workspace";
import { CaretLeft } from "components/Customer";
import { useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";
import styled from "styled-components";

const Dashboard = (props) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const [url, setUrl] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (user?.attributes?.sub) {
      const path = "/dashboard/:dashboardId";
      const match = matchPath(path, location.pathname);
      const dashboardId = match?.params?.dashboardId;
      console.log("DashboardId", dashboardId);
      if (!dashboardId) {
        console.error("DashboardId not found");
        return;
      }

      getQuicksightDashboardEmbedUrl(dashboardId, user.attributes.email).then(
        (res) => {
          console.log("getQuicksightDashboardEmbedUrl", res);
          const newUrl = res;
          setUrl(newUrl);
        }
      );
    }
  }, [user]);

  return (
    <>
      <div style={{ padding: 20, display: "flex", alignItems: "center" }}>
        <CaretLeft />
        <Anchor href="/dashboard">ダッシュボードリストに戻る</Anchor>
      </div>
      <div style={{ padding: "50px", width: "100%", height: "100%" }}>
        {url && (
          <iframe
            title="Dashboard"
            width="100%"
            height="100%"
            src={url}
            //
          ></iframe>
        )}
      </div>
    </>
  );
};

const Anchor = styled.a`
  display: block;
  text-decoration: none;
  color: rgba(35, 151, 206, 1);

  &:hover {
    font-weight: 700;
    color: #192e55;
  }
`;

export default Dashboard;
